import { graphql } from "@/gql";

export const markRelocationLineAsSoldMutation = graphql(`
  mutation RelocationLineMarkAsSold(
    $id: ID!
    $sold: Boolean!
    $soldBy: Competitor
  ) {
    relocationLineSold(id: $id, sold: $sold, soldBy: $soldBy) {
      id
    }
  }
`);
